import React, { createContext, useState, useEffect } from "react";
import carWash from '../Image/maxresdefault.jpg';
import oilChange from '../Image/Oil-change.jpg';
import engineRepair from '../Image/OIP1.webp';
import tireCare from '../Image/OIP2.webp';
import carPaint from '../Image/OIP3.webp';
import carInspection from '../Image/OIP4.webp';

export const ServicesContext = createContext();

export const ServicesProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [services, setServices] = useState([]);

  useEffect(() => {
    const data = [
      {
        image: carWash,
        title: "Car Washing",
        description: "Professional car washing service with premium products",
        price: "500",
        features: ["Exterior Washing", "Interior Cleaning", "Waxing", "Free Oiling"]
      },
      {
        image: oilChange,
        title: "Oil Change",
        description: "Complete oil change service with quality lubricants",
        price: "1500",
        features: ["Oil Filter Change", "Quality Oil", "Check Fluids", "Basic Inspection"]
      },
      {
        image: engineRepair,
        title: "Engine Service",
        description: "Complete engine diagnostics and repair",
        price: "2000",
        features: ["Diagnostics", "Repair", "Parts Replacement", "Performance Check"]
      },
      {
        image: tireCare,
        title: "Tire Service",
        description: "Tire maintenance and replacement service",
        price: "800",
        features: ["Tire Rotation", "Balancing", "Alignment", "Pressure Check"]
      },
      {
        image: carPaint,
        title: "Paint Service",
        description: "Professional car painting and touch-up",
        price: "5000",
        features: ["Body Work", "Paint Job", "Polishing", "Clear Coat"]
      },
      {
        image: carInspection,
        title: "Car Inspection",
        description: "Comprehensive vehicle inspection service",
        price: "1000",
        features: ["Safety Check", "Systems Test", "Report", "Consultation"]
      }
    ];

    setServices(data);
    setTimeout(() => setIsLoading(false), 1500);
  }, []);

  return (
    <ServicesContext.Provider value={{ services, setServices, isLoading }}>
      {children}
    </ServicesContext.Provider>
  );
};
